import React from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Link,
  Stack,
} from '@mui/material';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import PropTypes from 'prop-types';

import { TypoPoppBlue, TypoPoppins } from '../../../Components/Typo';

const ThankYou = props => {
  return (
    <Dialog
      maxWidth='xs'
      PaperProps={{
        sx: {
          m: { xs: 2, md: 'unset' },
          backgroundColor: 'white',
          p: { xs: '1em .5em 3em .5em', md: '2em 3em 6em 1em' },
          boxSizing: 'border-box',
          borderRadius: { xs: '12px', md: '40px' },
        },
      }}
      {...props}
    >
      <DialogContent>
        <Stack direction={{ xs: 'column', md: 'row' }}>
          <Box>
            <IconButton onClick={props.onClose}>
              <ChevronLeftIcon />
            </IconButton>
          </Box>
          <Stack gap={3}>
            <TypoPoppins
              textAlign='center'
              variant='h6'
              fontWeight={600}
              mb={1}
            >
              Thank you
            </TypoPoppins>
            <TypoPoppBlue textAlign='center'>
              Contact Details send to Professional so they will contact you
              soon.
            </TypoPoppBlue>
            <Link component={RouterLink} to='/' width='fit-content' mx='auto'>
              <Button
                color='blue'
                sx={{ color: 'white', fontWeight: 500, px: 5 }}
              >
                Home
              </Button>
            </Link>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

ThankYou.propTypes = { onClose: PropTypes.func };

export default ThankYou;
